module.exports = __webpack_public_path__ + "static/media/User.59a4d4a9.svg";